import css from 'styled-jsx/css';

const styles = css.global`.error_boundary_wrapper{display:flex;align-items:center;justify-content:center;padding:12.5rem 0 6.25rem 0;flex-direction:column;position:fixed;top:0;left:0;width:100%;height:100vh;background:var(--background);z-index:1000}.error_boundary_wrapper h1{color:var(--text)}.error_boundary_wrapper .bf_button{margin-top:1.875rem}`;

export default styles;